import dayjs from '~/timeInit';

export function getAlignVoucherUserExpiryBlockReason({
  usedAt,
  expiredAt,
  voucherExpiresAt,
  now,
}: {
  usedAt?: string | null;
  expiredAt?: string | null;
  voucherExpiresAt?: string | null;
  now: number;
}): string | undefined {
  if (usedAt) return 'Used assignments cannot be updated';
  if (!voucherExpiresAt || !dayjs(voucherExpiresAt).isValid()) return 'Voucher has no valid expiry date';
  if (!dayjs(voucherExpiresAt).isAfter(now)) return 'Voucher expiry must be in the future';
  if (expiredAt && dayjs(expiredAt).isValid() && dayjs(expiredAt).isSame(dayjs(voucherExpiresAt))) {
    return 'Assignment expiry already matches the voucher expiry';
  }
  return undefined;
}
